export default "__VITE_ASSET__576f23df__"